import { EntityTypeEnum } from '@crm/api'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Select } from 'antd'

export const CustomFieldsFilters = () => {
  const { t } = useLocales()

  const { params, updateQuery } = useQueryUpdate()

  const entityTypeOptions = Object.values(EntityTypeEnum).map((entityType) => ({
    label: t(`nomenclature.entity_type.${entityType}`),
    value: entityType
  }))

  const isDeletedOptions = [
    { label: t('nomenclature.inactive'), value: 'true' },
    { label: t('nomenclature.active'), value: 'false' }
  ]

  const isRequiredOptions = [
    { label: t('nomenclature.required'), value: 'true' },
    { label: t('nomenclature.not_required'), value: 'false' }
  ]

  return (
    <>
      <Select
        className="select-min-width"
        placeholder={t('nomenclature.type')}
        options={entityTypeOptions}
        value={params.entity_type}
        onChange={(value) => updateQuery({ entity_type: value })}
        allowClear
      />
      <Select
        className="select-min-width"
        placeholder={t('nomenclature.active')}
        options={isDeletedOptions}
        value={params.is_deleted}
        onChange={(value) => updateQuery({ is_deleted: value })}
        allowClear
      />
      <Select
        className="select-min-width"
        placeholder={t('nomenclature.required')}
        options={isRequiredOptions}
        value={params.is_required}
        onChange={(value) => updateQuery({ is_required: value })}
        allowClear
      />
    </>
  )
}
